import React from "react";
import { Filter, TextInput } from "react-admin";

export const BlogFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by blog title" source="title" alwaysOn />
  </Filter>
);
